export default "__VITE_ASSET__B_jzdM1H__"